import { API_URL } from '@constants'
import axiosReadInstance from '../../request/axiosReadInstance'
import ReactMarkdown from 'react-markdown'
import { cmsRehypePlugins } from '../../security/cmsMarkdown'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { usePageLoading } from '../../context/PageLoadingContext'

interface IAccessibility {
    title: string
    content: string
}

export const Accessibility = () => {
    const [accessibility, setAccessibility] = useState<IAccessibility>()
    const { incrementLoadingRequestCount, decrementLoadingRequestCount } =
        usePageLoading()

    const fetchData = useCallback(async () => {
        incrementLoadingRequestCount()
        try {
            const response = await axiosReadInstance.get(
                `${API_URL}/api/accessibility`
            )
            setAccessibility(response.data.data.attributes)
        } catch (error) {
            console.error('Error fetching accessibility data:', error)
        } finally {
            decrementLoadingRequestCount()
        }
    }, [incrementLoadingRequestCount, decrementLoadingRequestCount])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Listen too | Déclaration d&apos;accessibilité</title>
                <meta
                    name="description"
                    content="Consultez la déclaration d'accessibilité du site Listen too. Informations sur la conformité et les démarches d'amélioration."
                />
            </Helmet>
            <section className="bg-white  ">
                <div className="text-center px-6 md:px-[6rem] lg:px-[8rem] pb-8 mx-auto lg:gap-8 xl:gap-0">
                    <div className="mr-4 md:mt-[100px] text-justify">
                        <h1
                            className="mr-4 flex flex-wrap mt-[50px] text-left text-3xl font-semibold"
                            style={{ color: '#0A8335' }}
                        >
                            {accessibility?.title}
                        </h1>
                        <div className="mt-8 mb-6 text-gray-500 lg:mb-8 md:text-lg lg:text-sm ">
                            <ReactMarkdown
                                className="prose text-justify"
                                rehypePlugins={cmsRehypePlugins}
                            >
                                {accessibility?.content || ''}
                            </ReactMarkdown>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
